import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2510. 受注案件BoardProject連携削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_board_project
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
};

const destroySalesOrderBoardProject = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_board_project`
  );
};

export const useDestroySalesOrderBoardProject = () => {
  return useMutation({
    mutationFn: destroySalesOrderBoardProject,
  });
};
